export class AppConsts {

    static readonly appVersion = "v3.0.3";

    static remoteServiceBaseUrl: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish

    static localeMappings: any = [];

	static guidEmpty: string = "00000000-0000-0000-0000-000000000000";
	static readonly guidSpv: string = "F7B00E21-4E5E-EB11-912E-005056012243";
	static readonly guidCoordinator: string = "9BD6D10F-4E5E-EB11-912E-005056012243";

    static readonly userManagement = {
        defaultAdminUserName: 'admin'
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'BaseProject'
    };

    static readonly authorization = {
        encryptedAuthTokenName: 'enc_auth_token'
	};

	static readonly metabase = {
        //urlTranspop: 'http://192.168.100.245:3000'
        urlTranspop : 'http://stoktonetimv3.transpop.com.tr:3500'
    };

    /**
     * Urun fotograflarinin yayin yaptigi url
     */
    static readonly productImage = {
        url : 'https://stokyonetimv2.transpop.com.tr/productImages' 
    };

    static readonly wmsType = {
        wms1 : "WMS1",
        wms2 : "WMS2"
    }



    /**
     * UserCustomerTheme icin kullanilan logo ve imagelerin bulundugu directory
     */
    static readonly userCustomerTheme = {
        path : "assets/media/c-theme"
    };
    
    /**
     * PMS modulundeki POSM uretim akis form tipleridir.
     */
    static readonly pmsTaskforms = {

        /**
         * Standart TAMAMLANDI formu
         */
        AFK001 : "AFK001",

        /**
         * Üreticiden bütçe girişi bekleniyor
         */
        AFK002 : "AFK002",

        /**
         * Üretim bütçe onayı bekleniyor
         */
        AFK003 : "AFK003",

        /**
         * Üretim takvimi girişi bekleniyor
         */
        AFK004 : "AFK004",

        /**
         * Transpop tarafından depo teslimi bekleniyor
         */
        AFK005 : "AFK005",

        /**
         * Saha dağılım planı bekleniyor
         */
        AFK007 : "AFK007",

        /**
         * Görselin Tasarima Uyarlanması Bekleniyor
         */
        AFK008 : "AFK008",

        /**
         * Görselin Tasarima Uyarlanma onayı Bekleniyor
         */
        AFK009 : "AFK009",
    }


    
}
